
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-ka4djm",
"minContentWidth": "--awsui-min-content-width-ka4djm",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-ka4djm",
"contentGapLeft": "--awsui-content-gap-left-ka4djm",
"contentGapRight": "--awsui-content-gap-right-ka4djm",
"contentHeight": "--awsui-content-height-ka4djm",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-ka4djm",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-ka4djm",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-ka4djm",
"defaultMaxContentWidth": "--awsui-default-max-content-width-ka4djm",
"defaultMinContentWidth": "--awsui-default-min-content-width-ka4djm",
"drawerSize": "--awsui-drawer-size-ka4djm",
"drawerMinSize": "--awsui-drawer-min-size-ka4djm",
"bottomDrawerSize": "--awsui-bottom-drawer-size-ka4djm",
"footerHeight": "--awsui-footer-height-ka4djm",
"headerGap": "--awsui-header-gap-ka4djm",
"headerHeight": "--awsui-header-height-ka4djm",
"layoutWidth": "--awsui-layout-width-ka4djm",
"mainGap": "--awsui-main-gap-ka4djm",
"mainOffsetLeft": "--awsui-main-offset-left-ka4djm",
"mainTemplateRows": "--awsui-main-template-rows-ka4djm",
"mobileBarHeight": "--awsui-mobile-bar-height-ka4djm",
"notificationsHeight": "--awsui-notifications-height-ka4djm",
"offsetTop": "--awsui-offset-top-ka4djm",
"overlapHeight": "--awsui-overlap-height-ka4djm",
"navigationWidth": "--awsui-navigation-width-ka4djm",
"navigationCollapsedWidth": "--awsui-navigation-collapsed-width-ka4djm",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-ka4djm",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-ka4djm",
"splitPanelHeight": "--awsui-split-panel-height-ka4djm",
"splitPanelMinWidth": "--awsui-split-panel-min-width-ka4djm",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-ka4djm",
"toolsMaxWidth": "--awsui-tools-max-width-ka4djm",
"toolsWidth": "--awsui-tools-width-ka4djm",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-ka4djm",
"contentScrollMargin": "--awsui-content-scroll-margin-ka4djm",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-ka4djm",
"flashbarStackIndex": "--awsui-flashbar-stack-index-ka4djm",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-ka4djm",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-ka4djm",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-ka4djm",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-ka4djm",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-ka4djm",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-ka4djm",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-ka4djm",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-ka4djm",
"modalCustomWidth": "--awsui-modal-custom-width-ka4djm",
"modalCustomHeight": "--awsui-modal-custom-height-ka4djm",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-ka4djm",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-ka4djm",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-ka4djm",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-ka4djm",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-ka4djm",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-ka4djm",
"sliderLabelCount": "--awsui-slider-label-count-ka4djm",
"sliderTickCount": "--awsui-slider-tick-count-ka4djm",
"sliderReferenceColumn": "--awsui-slider-reference-column-ka4djm",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-ka4djm",
"sliderMaxStart": "--awsui-slider-max-start-ka4djm",
"sliderMinEnd": "--awsui-slider-min-end-ka4djm",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-ka4djm",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-ka4djm",
"togglesLeftWidth": "--awsui-toggles-left-width-ka4djm",
"togglesRightWidth": "--awsui-toggles-right-width-ka4djm",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-ka4djm",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-ka4djm",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-ka4djm",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-ka4djm",
"styleBackgroundActive": "--awsui-style-background-active-ka4djm",
"styleBackgroundDefault": "--awsui-style-background-default-ka4djm",
"styleBackgroundDisabled": "--awsui-style-background-disabled-ka4djm",
"styleBackgroundHover": "--awsui-style-background-hover-ka4djm",
"styleBorderColorActive": "--awsui-style-border-color-active-ka4djm",
"styleBorderColorDefault": "--awsui-style-border-color-default-ka4djm",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-ka4djm",
"styleBorderColorHover": "--awsui-style-border-color-hover-ka4djm",
"styleColorActive": "--awsui-style-color-active-ka4djm",
"styleColorDefault": "--awsui-style-color-default-ka4djm",
"styleColorDisabled": "--awsui-style-color-disabled-ka4djm",
"styleColorHover": "--awsui-style-color-hover-ka4djm",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-ka4djm",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-ka4djm",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-ka4djm",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-ka4djm",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-ka4djm",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-ka4djm",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-ka4djm",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-ka4djm",
"styleBackgroundReadonly": "--awsui-style-background-readonly-ka4djm",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-ka4djm",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-ka4djm",
"styleColorReadonly": "--awsui-style-color-readonly-ka4djm",
"styleBackgroundFocus": "--awsui-style-background-focus-ka4djm",
"styleBorderColorFocus": "--awsui-style-border-color-focus-ka4djm",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-ka4djm",
"styleColorFocus": "--awsui-style-color-focus-ka4djm",
"stylePlaceholderColor": "--awsui-style-placeholder-color-ka4djm",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-ka4djm",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-ka4djm",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-ka4djm",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-ka4djm",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-ka4djm",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-ka4djm",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-ka4djm",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-ka4djm",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-ka4djm",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-ka4djm",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-ka4djm",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-ka4djm",
"alertIconColor": "--awsui-alert-icon-color-ka4djm",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-ka4djm",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-ka4djm",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-ka4djm",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-ka4djm",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-ka4djm",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-ka4djm",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-ka4djm",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-ka4djm",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-ka4djm",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-ka4djm",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-ka4djm",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-ka4djm",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-ka4djm",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-ka4djm",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-ka4djm",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-ka4djm",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-ka4djm",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-ka4djm",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-ka4djm",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-ka4djm",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-ka4djm",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-ka4djm",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-ka4djm",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-ka4djm",
"promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-ka4djm",
"promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-ka4djm",
"promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-ka4djm",
"promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-ka4djm",
"optionBackgroundDefault": "--awsui-option-background-default-ka4djm",
"optionBackgroundHighlighted": "--awsui-option-background-highlighted-ka4djm",
"optionBackgroundSelected": "--awsui-option-background-selected-ka4djm",
"optionColorDefault": "--awsui-option-color-default-ka4djm",
"optionColorHighlighted": "--awsui-option-color-highlighted-ka4djm",
"optionColorDisabled": "--awsui-option-color-disabled-ka4djm",
"optionGroupLabelColor": "--awsui-option-group-label-color-ka4djm",
"optionFilterMatchBackground": "--awsui-option-filter-match-background-ka4djm",
"optionFilterMatchColor": "--awsui-option-filter-match-color-ka4djm",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-ka4djm",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-ka4djm",
"progressBarHeight": "--awsui-progress-bar-height-ka4djm",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-ka4djm",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-ka4djm",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-ka4djm",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-ka4djm",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-ka4djm",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-ka4djm",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-ka4djm",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-ka4djm",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-ka4djm",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-ka4djm",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-ka4djm",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-ka4djm",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-ka4djm",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-ka4djm",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-ka4djm",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-ka4djm",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-ka4djm",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-ka4djm",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-ka4djm",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-ka4djm",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-ka4djm",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-ka4djm",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-ka4djm",
"inlineLabelBackgroundColor": "--awsui-inline-label-background-color-ka4djm",
"containerStyleBorderRadius": "--awsui-container-style-border-radius-ka4djm",
      };
      export default customCSSPropertiesMap;
    